import React, { forwardRef } from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Divider,
  Stack,
} from "@mui/material";

// This forwardRef allows react-to-print to print just this component
const SaleReceipt = forwardRef(({ sale, branches }, ref) => {
  return (
    <Box
      component="div"
      ref={ref}
      sx={{ p: 3, width: "auto", maxWidth: 600, m: "auto" }}
    >
      <Typography variant="h6" align="center" gutterBottom>
        {sale?.receiptTitle || "JASS Educational Services Pvt. Ltd."}
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="subtitle2">
          Receipt No: {sale?.receiptNo || sale?._id}
        </Typography>
        {sale?.manualReceiptNumber && (
          <Typography variant="subtitle2">
            Manual Receipt No: {sale.manualReceiptNumber}
          </Typography>
        )}
        <Typography variant="subtitle2">
          Date: {sale?.saleDate ? new Date(sale.saleDate).toLocaleString() : ""}
        </Typography>
      </Stack>
      <Divider sx={{ my: 1 }} />
      <Typography variant="subtitle2">
        Student: {sale?.studentName} ({sale?.studentId})
      </Typography>
      <Typography variant="subtitle2">
        Grade: {sale?.grade} | Program: {sale?.program}
      </Typography>
      <Typography variant="subtitle2">
        Branch:{" "}
        {branches.find((b) => b._id === sale?.branch)?.name || "Central Org"}
      </Typography>
      <Divider sx={{ my: 2 }} />
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Item/Collection</TableCell>
              <TableCell align="right">Qty</TableCell>
              {/* <TableCell align="right">Price</TableCell> */}
              <TableCell align="right">Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(sale?.items || []).map((item, idx) => (
              <TableRow key={idx}>
                <TableCell>
                  {item.isCollection
                    ? "[Set] " + (item.collection?.name || "")
                    : item.item?.name || ""}
                </TableCell>
                <TableCell align="right">{item.quantity}</TableCell>
                {/* <TableCell align="right">₹{item.price}</TableCell> */}
                <TableCell align="right">
                  ₹{(item.quantity * item.price).toLocaleString()}
                </TableCell>
              </TableRow>
            ))}
            {(sale?.discountVouchers || []).map((v, idx) => (
              <TableRow key={`voucher-${idx}`}>
                <TableCell colSpan={2} align="right">
                  Discount {v.code ? `(${v.code})` : ""}
                </TableCell>
                <TableCell align="right">
                  – ₹{parseFloat(v.amount || 0).toLocaleString()}
                </TableCell>
              </TableRow>
            ))}
            {sale.roundOff !== 0 && (
              <TableRow>
                <TableCell colSpan={2} align="right">
                  Round Off
                </TableCell>
                <TableCell align="right">
                  ₹{parseFloat(sale.roundOff).toLocaleString()}
                </TableCell>
              </TableRow>
            )}
            <TableRow>
              <TableCell colSpan={2} align="right">
                <strong>Grand Total</strong>
              </TableCell>
              <TableCell align="right">
                <strong>₹{sale?.totalAmount?.toLocaleString()}</strong>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      <Divider sx={{ my: 2 }} />
      {sale?.payments?.length > 1 ? (
        <>
          <Typography variant="subtitle2" gutterBottom>
            Payment Breakdown
          </Typography>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Mode</TableCell>
                  <TableCell align="right">Amount</TableCell>
                  <TableCell>Reference</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sale.payments.map((p, idx) => (
                  <TableRow key={idx}>
                    <TableCell>{p.mode}</TableCell>
                    <TableCell align="right">
                      ₹{parseFloat(p.amount).toLocaleString()}
                    </TableCell>
                    <TableCell>{p.info || "-"}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      ) : (
        <Typography variant="subtitle2">
          Payment Mode:{" "}
          {sale?.payments?.[0]?.mode || sale?.paymentMode || "-"}
          {(sale?.payments?.[0]?.info || sale?.paymentInfo)
            ? " | Ref: " + (sale?.payments?.[0]?.info || sale?.paymentInfo)
            : ""}
        </Typography>
      )}
      <Typography variant="body2" sx={{ mt: 2, color: "gray" }}>
        Thank you!
      </Typography>
      <Box sx={{ mt: 4, textAlign: "right" }}>
        <Typography variant="caption">Powered by JASS ERP System</Typography>
      </Box>
    </Box>
  );
});

export default SaleReceipt;
